import { styled } from "styled-components";
import { Sidebar } from "../../../App/SideBar";
import Theme from "../../../../styles/Theme/Theme";
import React, { useEffect, useState } from "react";
import { RegisterBuildingHelper } from "./RegisterBuildingHelper";
import { useLocation } from "react-router-dom";
import { BuildingHeader } from "../../Molecules/BuildingDetails/BuildingHeader";
import { Footer } from "../../../App/Footer";
import { useAuthContext } from "../../../../contexts/AuthContext";
import { RegisterWeatherServiceHelper } from "./RegisterWeatherServiceHelper";

//#region  Styled Components
//Where we define the styles, CSS and other aspects for the page components
const DetailWrapper = styled.div`
  display: flex;
  flex-direction: row;
  min-height: 100%;
  background-color: ${Theme.color["neutral-1"]};
`;

const RightContent = styled.div`
 display:flex;
 flex-direction:column;
 justify-content:space-between;
  width: calc(100% - 235px);
  overflow-y:auto;
  .tab_component_children {
    padding: ${Theme.spacing.s05};
    box-sizing: border-box;
  }
`;

//#endregion

export const RegisterComponent = ({ item, tabsHelper }) => {
  // const { tags } = useAuthContext();
  const tags = JSON.parse(localStorage.getItem('mico_tags'));
  const location = useLocation();
  const [currentTab, setCurrentTab] = useState(
    location.hash
      ? location.hash.replace("#", "")
      : tabsHelper?.[0].label
  );
  const tabItem = tabsHelper?.find(
    (entry) => entry.label === currentTab
  );
  const [headerSelectedTab, setHeaderSelectedTab] = useState(
    tabItem?.buttons?.[0]
  );
  const [currentFloor, setCurrentFloor] = useState(null);

  if (location.hash === "") {
    window.location.hash = "#" + currentTab;
  }

  const getComponentByTab = () => {
    //Verifica qual o index the sub tab selecionada dentro do header, para depois renderizar o componente correto.
    const headerTabIndex = tabItem?.buttons.findIndex(
      (x) => x === headerSelectedTab
    );
    const finalHeaderTabIndex = headerTabIndex >= 0 ? headerTabIndex : 0;
    return tabItem?.component[finalHeaderTabIndex];
  };

  const OpenTabComponent = getComponentByTab();

  const changeHeaderSelectedTab = (headerTab) => {
    setHeaderSelectedTab(headerTab);
  };

  const changeHeaderFloor = (floor) => {
    setCurrentFloor(floor);
  };

  return (
    <DetailWrapper>
      <Sidebar
        sideBarMenu={tabsHelper?.filter((item) => tags.includes(item.label))}
        activeTab={currentTab}
        setCurrentTab={setCurrentTab}
      />
      {tags.includes(currentTab) ?
        <RightContent>
          <div>
            <BuildingHeader
              item={item}
              buttons={tabItem?.buttons}
              changeHeaderSelectedTab={changeHeaderSelectedTab}
              changeHeaderFloor={changeHeaderFloor}
              hideHeaderDropdwon={tabItem?.hideHeader?.find(x => x === headerSelectedTab) ?? false}
            />
            {/* {currentFloor ? */}
              <OpenTabComponent
                item={item}
                currentFloor={currentFloor}
                headerSelectedTab={headerSelectedTab}
                className={"tab_component_children"}
              />
              {/* : null} */}
          </div>
          <Footer />
        </RightContent>
        : null}
    </DetailWrapper>
  );
};